import Tooltip from '@ui/tooltip/Tooltip';
import api from '@utils/api';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
const UploadFiles = (props) => {
    const { t } = useTranslation();
    const [fileBeingUploaded, setFileBeingUploaded] = useState();
    const [progress, setProgress] = useState(0);
    const [uploadedFile, setUploadedFile] = useState();
    const [error, setError] = useState();
    useEffect(() => {
        setUploadedFile(props.uploadedFile);
    }, [props.uploadedFile]);
    const selectFile = (event) => {
        setError(null);
        let file = event.target.files[0];
        if (props.filetype === 'IMAGES') {
            if (file.type.indexOf('image/') == -1) {
                setError(t('aftercare.images.notallowed'));
                return;
            }
        }
        setFileBeingUploaded(file);
        setProgress(0);
        api
            .uploadFile(props.formfield, file, (event) => {
            setProgress(Math.round((100 * event.loaded) / event.total));
        })
            .then((response) => {
            setUploadedFile(response.filename);
            setFileBeingUploaded(undefined);
            props.selectedFile && props.selectedFile(file.name);
            props.onFileChange && props.onFileChange(response.filename);
        })
            .catch(() => {
            setError(t('aftercare.images.error'));
            setFileBeingUploaded(undefined);
            props.onFileChange && props.onFileChange(undefined);
            props.selectedFile && props.selectedFile(undefined);
        });
    };
    const removeFile = () => {
        if (uploadedFile) {
            api.removeFile(props.formfield, uploadedFile).then((response) => {
                setUploadedFile(undefined);
                props.onFileChange && props.onFileChange(undefined);
                props.selectedFile && props.selectedFile(undefined);
            });
        }
    };
    if (fileBeingUploaded) {
        return (React.createElement("div", { className: "button  button--fileupload image-button image-button-progress" },
            React.createElement("div", { className: "progress-bar", role: "progressbar", "aria-valuenow": progress, "aria-valuemin": 0, "aria-valuemax": 100 },
                progress,
                "%")));
    }
    if (uploadedFile) {
        return (React.createElement("div", { className: "button button--fileupload image-button image-button-remove" },
            React.createElement(React.Fragment, null,
                props.label,
                " ",
                t('aftercare.images.added'),
                React.createElement("button", { type: "button", className: "cta cta--remove", onClick: removeFile }, t('button.remove')))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "button button--fileupload image-button image-button-add" },
            React.createElement("label", null,
                props.label,
                " ",
                props.required ? ' *' : '',
                React.createElement("input", { type: "file", onChange: selectFile, accept: props.filetype == 'IMAGES' ? '.gif,.jpg,.jpeg,.png' : undefined })),
            props.tooltipText && React.createElement(Tooltip, { ariaLabel: t('label.info'), id: props.formfield, text: props.tooltipText })),
        props.requiredError && React.createElement("div", { className: "invalid-feedback" }, t('aftercare.requiredimage')),
        error && React.createElement("div", { className: "invalid-feedback" }, error)));
};
export default UploadFiles;
